import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../Context/UserContext";
import MyInput from "../../Reusable/MyInput";
import Button from "../../Reusable/Button";
import toast from "react-hot-toast";
import { BaseURL } from "../../Reusable/BaseURL";
import { FetchCustomSelect } from "../../Reusable/FetchCustomSelect";
import PartyPageForm from "../../masterFormPages/PartyPageForm";
import MyTextarea from "../../Reusable/MyTextarea";
import { CitySelect } from "../../Reusable/CitySelect";
import { StateSelect } from "../../Reusable/StateSelectTest";
import { PartyIsSelect } from "../../Reusable/PartyIsSelect";
import { PartyRoleSelect } from "../../Reusable/PartyRoleSelect";
import { PartyDivisionSelect } from "./PartyDivisionSelect";
import { DisableContext } from "../../Context/DisableContext";
// import FormData from "form-data";

export default function PartyTest() {
  const { darkTheme, loginData, allPermiss } = useContext(UserContext);
  const { setDisableParty, disableParty } = useContext(DisableContext);
  const [division, setDivision] = useState("");
  const [partyRole, setPartyRole] = useState("");
  const [partyIs, setPartyIs] = useState("");
  const [dateOfIntroduction, setDateOfIntroduction] = useState("");
  const [partyName, setPartyName] = useState("");
  const [shortName, setShortName] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [state, setState] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [city, setCity] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [panNo, setPanNo] = useState("");
  const [aadhaarNo, setAadhaarNo] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [email, setEmail] = useState("");
  const [contactPersonOne, setContactPersonOne] = useState("");
  const [contactPersonTwo, setContactPersonTwo] = useState("");
  const [contactPersonTwoMobile, setContactPersonTwoMobile] = useState("");
  const [contactPersonOneMobile, setContactPersonOneMobile] = useState("");
  const [bank, setBank] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [isTds, setIsTds] = useState("");
  const [isMsme, setIsMsme] = useState("");

  const [identityProof, setIdentityProof] = useState(null);
  const [gstCertificate, setGstCertificate] = useState(null);
  const [msmeCertificate, setMsmeCertificate] = useState(null);
  const [bankDetail, setBankDetail] = useState(null);

  const [links, setLinks] = useState([]);
  const [firstPage, setFirstPage] = useState([]);
  const [totalNo, setTotalNo] = useState(0);
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [getId, setGetId] = useState(0);
  const [spinner, setSpinner] = useState(true);

  const [changingSelect, setChangingSelect] = useState(false);

  const [submitAction, setSubmitAction] = useState("submit");

  // disabled action
  const [submitDisable, setSubmitDisable] = useState(false);
  const [updateDisable, setUpdateDisable] = useState(false);
  const [editDisable, setEditDisable] = useState(false);

  // today current date
  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    setDateOfIntroduction(formattedDate);
  }, []);

  // create
  // create Division
  async function Create(e) {
    e.preventDefault();
    // if(!division || !aadhaarNo || !city || !state || !panNo || !gstNo){
    if (!aadhaarNo || !city || !state || !panNo || !gstNo) {
      return toast.error("The required field is Empty !");
    }
    setSubmitDisable(true);

    // const formdata= {
    //   "name": partyName,
    //   "full_address": fullAddress,
    //   "state_id": state.value,
    //   "city_id": city.value,
    //   "gst_no": gstNo,
    //   "pan_no": panNo,
    //   "aadhaar_no": aadhaarNo,
    //   "bank": bank,
    //   "bank_account": bankAccount,
    //   "bank_branch": bankBranch,
    //   "contact_person_one": contactPersonOne,
    //   "contact_person_one_mobile": contactPersonOneMobile,
    //   "contact_person_two": contactPersonTwo,
    //   "contact_person_two_mobile": contactPersonTwoMobile,
    //   "date_of_introduction": dateOfIntroduction,
    //   "email": email,
    //   "ifsc": ifsc,
    //   "mobile_no": mobileNo,
    //   "party_role": partyRole.value,
    //   "party_is": partyIs.value,
    //   "phone_no": phoneNo,
    //   "short_name": shortName,
    //  "identity_proof": identityProof,
    //  "gst_certificate": gstCertificate,
    //  "msme_certificate": msmeCertificate,
    //  "bank_detail": bankDetail,
    // }

    const formdata = new FormData();
    formdata.append("name", partyName);
    formdata.append("full_address", fullAddress);
    formdata.append("state_id", state.value || "");
    formdata.append("city_id", city.value || "");
    formdata.append("gst_no", gstNo);
    formdata.append("pan_no", panNo);
    formdata.append("aadhaar_no", aadhaarNo);
    formdata.append("bank", bank);
    formdata.append("bank_account", bankAccount);
    formdata.append("bank_branch", bankBranch);
    formdata.append("contact_person_one", contactPersonOne);
    formdata.append("contact_person_one_mobile", contactPersonOneMobile);
    formdata.append("contact_person_two", contactPersonTwo);
    formdata.append("contact_person_two_mobile", contactPersonTwoMobile);
    formdata.append("date_of_introduction", dateOfIntroduction);
    formdata.append("email", email);
    formdata.append("ifsc", ifsc);
    formdata.append("mobile_no", mobileNo);
    formdata.append("party_role", partyRole.value || "");
    formdata.append("party_is", partyIs.value || "");
    formdata.append("phone_no", phoneNo);
    formdata.append("short_name", shortName);
    formdata.append("is_msme", isMsme);
    formdata.append("is_tds", isTds);
    formdata.append("identity_proof", identityProof || "");
    formdata.append("gst_certificate", gstCertificate || "");
    formdata.append("msme_certificate", msmeCertificate || "");
    formdata.append("bank_detail", bankDetail || "");

    const res = await fetch(`${BaseURL}/parties`, {
      method: "POST",
      // body: JSON.stringify(formdata),
      body: formdata,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        // "Content-Type": "multipart/form-data",
        // "Content-Type": "application/json"
      },
    })
      .then((resdata) => resdata.json())
      .then((createRes) => {
        console.log("submitPartydata:", identityProof);
        if (createRes.status) {
          firstPageList();
          toast.success("Success");
          setDivision("");
          setPartyRole("");
          setPartyIs("");
          setDateOfIntroduction("");
          setPartyName("");
          setShortName("");
          setFullAddress("");
          setState("");
          setStateCode("");
          setCity("");
          setGstNo("");
          setPanNo("");
          setAadhaarNo("");
          setMobileNo("");
          setPhoneNo("");
          setEmail("");
          setContactPersonOne("");
          setContactPersonTwo("");
          setContactPersonOneMobile("");
          setContactPersonTwoMobile("");
          setBank("");
          setBankBranch("");
          setBankAccount("");
          setIfsc("");
          setIsTds("");
          setIsMsme("");
          setIdentityProof(null);
          setGstCertificate(null);
          setBankDetail(null);
          setMsmeCertificate(null);

          setMsmeCertImgName("No file selected");
          setBankDetImgName("No file selected");
          setGstCertImgName("No file selected");
          setIdProofImgName("No file selected");

          setSubmitDisable(false);
        }
        if (createRes.status === false) {
          setSubmitDisable(false);
        }
        if (createRes?.error?.message.name) {
          toast.error(createRes.error.message.name);
        } else if (createRes?.error?.message.city_id) {
          toast.error(createRes.error.message.city_id);
        } else if (createRes?.error?.message.state_id) {
          toast.error(createRes.error.message.state_id);
        } else if (createRes?.error?.message.full_address) {
          toast.error(createRes.error.message.full_address);
        } else if (createRes?.error?.message.gst_no) {
          toast.error(createRes.error.message.gst_no);
        } else if (createRes?.error?.message.pan_no) {
          toast.error(createRes.error.message.pan_no);
        } else if (createRes?.error?.message.aadhaar_no) {
          toast.error(createRes.error.message.aadhaar_no);
        } else if (createRes?.error?.message?.identity_proof) {
          toast.error(createRes.error.message.identity_proof);
        } else if (createRes?.error?.message?.gst_certificate) {
          toast.error(createRes.error.message.gst_certificate);
        } else if (createRes?.error?.message?.bank_detail) {
          toast.error(createRes.error.message.bank_detail);
        } else if (createRes?.error?.message?.msme_certificate) {
          toast.error(createRes.error.message.msme_certificate);
        } else if (createRes?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  // Listing record
  function firstPageList(url = `${BaseURL}/parties?page=1`) {
    setSpinner(true);
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((li) => {
        if (li?.status) {
          const revData = li.data.data.reverse();
          setFirstPage(revData);
          setTotalNo(li.data.total);
          setTo(li.data.to);
          setFrom(li.data.from);
          setLinks(li.data.links);
          setSpinner(false);
        }
      });
  }

  const editBtn = (editData) => {
    if (editData) {
      toast.success("Going to update form..");

      setEditDisable(true);
      setChangingSelect(true);
      setSubmitAction("update");
      // setPartyRole(selectedRecord.data.party_role || "");
      setPartyRole(editData.party_role || "");
      setPartyIs(editData.party_is || "");
      setDateOfIntroduction(editData.date_of_introduction || "");
      setPartyName(editData.name || "");
      setShortName(editData.short_name || "");
      setFullAddress(editData.full_address || "");
      setState(editData.state || "");
      setStateCode(editData.state_code || "");
      setCity(editData.city || "");
      setGstNo(editData.gst_no || "");
      setPanNo(editData.pan_no || "");
      setAadhaarNo(editData.aadhaar_no || "");
      setMobileNo(editData.mobile_no || "");
      setPhoneNo(editData.phone_no || "");
      setEmail(editData.email || "");
      setContactPersonOne(editData.contact_person_one || "");
      setContactPersonTwo(editData.contact_person_two || "");
      setContactPersonOneMobile(editData.contact_person_one_mobile || "");
      setContactPersonTwoMobile(editData.contact_person_two_mobile || "");
      setBank(editData.bank || "");
      setBankBranch(editData.bank_branch || "");
      setBankAccount(editData.bank_account || "");
      setIfsc(editData.ifsc || "");
      setIsTds(editData.is_tds || "");
      setIsMsme(editData.is_msme || "");
      // setIdentityProof(selectedRecord.data.identity_proof || null);
      // setGstCertificate(selectedRecord.data.gst_certificate || null);
      // setBankDetail(selectedRecord.data.bank_detail || null);
      // setMsmeCertificate(selectedRecord.data.msme_certificate || null);

      // setChangingSelect(true);
      setEditDisable(false);

      // TOP SCROLLING ==========
      // const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // You can use 'auto' instead of 'smooth' for instant scrolling
      });
      // };
    } else {
      setChangingSelect(false);
      setEditDisable(false);
    }
  };
  // UPDATE A RECORD
  async function updateARecord(e, id) {
    e.preventDefault();
    // if(!division || !aadhaarNo || !city || !state || !panNo || !gstNo){
    if (!aadhaarNo || !city || !state || !panNo || !gstNo) {
      return toast.error("The required field is Empty !");
    }
    // console.log("idddentityProof", identityProof)
    setUpdateDisable(true);
    // const formData = {
    //   name: partyName,
    //   full_address: fullAddress,
    //   state_id: state.value,
    //   city_id: city.value,
    //   gst_no: gstNo,
    //   pan_no: panNo,
    //   aadhaar_no: aadhaarNo,
    //   bank: bank,
    //   bank_account: bankAccount,
    //   bank_branch: bankBranch,
    //   contact_person_one: contactPersonOne,
    //   contact_person_one_mobile: contactPersonOneMobile,
    //   contact_person_two: contactPersonTwo,
    //   contact_person_two_mobile: contactPersonTwoMobile,
    //   date_of_introduction: dateOfIntroduction,
    //   email: email,
    //   ifsc: ifsc,
    //   mobile_no: mobileNo,
    //   party_role: partyRole.value || "",
    //   party_is: partyIs.value || "",
    //   phone_no: phoneNo,
    //   short_name: shortName,
    //   is_tds: isTds,
    //   is_msme: isMsme,
    //   // identity_proof: identityProof || null,
    //   // gst_certificate: gstCertificate || null,
    //   // msme_certificate: msmeCertificate || null,
    //   // bank_detail: bankDetail || null,
    //   identity_proof: identityProof || "",
    //   gst_certificate: gstCertificate || "",
    //   msme_certificate: msmeCertificate || "",
    //   bank_detail: bankDetail || "",
    // };

    const formdata = new FormData();
    formdata.append("name", partyName);
    formdata.append("full_address", fullAddress);
    formdata.append("state_id", state.value || "");
    formdata.append("city_id", city.value || "");
    formdata.append("gst_no", gstNo);
    formdata.append("pan_no", panNo);
    formdata.append("aadhaar_no", aadhaarNo);
    formdata.append("bank", bank);
    formdata.append("bank_account", bankAccount);
    formdata.append("bank_branch", bankBranch);
    formdata.append("contact_person_one", contactPersonOne);
    formdata.append("contact_person_one_mobile", contactPersonOneMobile);
    formdata.append("contact_person_two", contactPersonTwo);
    formdata.append("contact_person_two_mobile", contactPersonTwoMobile);
    formdata.append("date_of_introduction", dateOfIntroduction);
    formdata.append("email", email);
    formdata.append("ifsc", ifsc);
    formdata.append("mobile_no", mobileNo);
    formdata.append("party_role", partyRole.value || "");
    formdata.append("party_is", partyIs.value || "");
    formdata.append("phone_no", phoneNo);
    formdata.append("short_name", shortName);
    formdata.append("is_msme", isMsme);
    formdata.append("is_tds", isTds);
    formdata.append("identity_proof", identityProof || "");
    formdata.append("gst_certificate", gstCertificate || "");
    formdata.append("msme_certificate", msmeCertificate || "");
    formdata.append("bank_detail", bankDetail || "");

    const updRes = await fetch(`${BaseURL}/parties/${id}`, {
      method: "PATCH",
      // body: JSON.stringify(formData),
      body: formdata,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
        // "Content-Type": "application/json",
      },
      // body: JSON.stringify({name: divisionName}),
    })
      .then((res) => res.json())
      .then((upd) => {
        if (upd.status) {
          firstPageList();
          setGetId(0);
          toast.success("Updated");
          setDivision("");
          setPartyRole("");
          setPartyIs("");
          setDateOfIntroduction("");
          setPartyName("");
          setShortName("");
          setFullAddress("");
          setState("");
          setStateCode("");
          setCity("");
          setGstNo("");
          setPanNo("");
          setAadhaarNo("");
          setMobileNo("");
          setPhoneNo("");
          setEmail("");
          setContactPersonOne("");
          setContactPersonTwo("");
          setContactPersonOneMobile("");
          setContactPersonTwoMobile("");
          setBank("");
          setBankBranch("");
          setBankAccount("");
          setIfsc("");
          setIsTds("");
          setIsMsme("");
          setIdentityProof(null);
          setGstCertificate(null);
          setBankDetail(null);
          setMsmeCertificate(null);
          setSubmitAction("submit");

          setMsmeCertImgName("No file selected");
          setBankDetImgName("No file selected");
          setGstCertImgName("No file selected");
          setIdProofImgName("No file selected");

          setUpdateDisable(false);
        }

        if (upd.status === false) {
          setUpdateDisable(false);
        }

        if (upd?.error?.message.name) {
          toast.error(upd.error.message.name);
        } else if (upd?.error?.message.city_id) {
          toast.error(upd.error.message.city_id);
        } else if (upd?.error?.message.state_id) {
          toast.error(upd.error.message.state_id);
        } else if (upd?.error?.message.full_address) {
          toast.error(upd.error.message.full_address);
        } else if (upd?.error?.message.gst_no) {
          toast.error(upd.error.message.gst_no);
        } else if (upd?.error?.message.pan_no) {
          toast.error(upd.error.message.pan_no);
        } else if (upd?.error?.message.aadhaar_no) {
          toast.error(upd.error.message.aadhaar_no);
        } else if (upd?.error?.message?.identity_proof) {
          toast.error(upd.error.message.identity_proof);
        } else if (upd?.error?.message?.gst_certificate) {
          toast.error(upd.error.message.gst_certificate);
        } else if (upd?.error?.message?.bank_detail) {
          toast.error(upd.error.message.bank_detail);
        } else if (upd?.error?.message?.msme_certificate) {
          toast.error(upd.error.message.msme_certificate);
        } else if (upd?.error?.message) {
          toast.error("Oops! its 404");
        }
      });
  }

  function cancelUpdate() {
    setSubmitAction("submit");
    setDivision("");
    setPartyRole("");
    setPartyIs("");
    setDateOfIntroduction("");
    setPartyName("");
    setShortName("");
    setFullAddress("");
    setState("");
    setStateCode("");
    setCity("");
    setGstNo("");
    setPanNo("");
    setAadhaarNo("");
    setMobileNo("");
    setPhoneNo("");
    setEmail("");
    setContactPersonOne("");
    setContactPersonTwo("");
    setContactPersonOneMobile("");
    setContactPersonTwoMobile("");
    setBank("");
    setBankBranch("");
    setBankAccount("");
    setIfsc("");
    setIsTds("");
    setIsMsme("");
    setIdentityProof(null);
    setGstCertificate(null);
    setBankDetail(null);
    setMsmeCertificate(null);
    setGetId(0);

    setMsmeCertImgName("No file selected");
    setBankDetImgName("No file selected");
    setGstCertImgName("No file selected");
    setIdProofImgName("No file selected");
  }

  // MEDIA FILE ATTACHED FUNCTIONS
  const [idProofImgName, setIdProofImgName] = useState("No file selected");
  const [gstCertImgName, setGstCertImgName] = useState("No file selected");
  const [bankDetImgName, setBankDetImgName] = useState("No file selected");
  const [msmeCertImgName, setMsmeCertImgName] = useState("No file selected");
  function IdentityProofFun(e) {
    setIdentityProof(e.target.files[0]);
    setIdProofImgName(
      e.target.files[0] ? e.target.files[0].name : "No file selected"
    );
  }
  function GstCertificateFun(e) {
    setGstCertificate(e.target.files[0]);
    setGstCertImgName(
      e.target.files[0] ? e.target.files[0].name : "No file selected"
    );
  }
  function BankDetailFun(e) {
    setBankDetail(e.target.files[0]);
    setBankDetImgName(
      e.target.files[0] ? e.target.files[0].name : "No file selected"
    );
  }
  function MsmeCertificateFun(e) {
    setMsmeCertificate(e.target.files[0]);
    setMsmeCertImgName(
      e.target.files[0] ? e.target.files[0].name : "No file selected"
    );
  }

  return (
    <div
      className={`p-2 pb-8 rounded-xl text-sm ${
        darkTheme ? "bg-slate-600" : "bg-slate-100"
      }`}
    >
      <div>
        <div>
          <div
            className={`font-[600] text-sm uppercase text-center my-2 border-b bg-[#b4a996] py-1 mb-4 rounded-tr-lg rounded-tl-lg ${
              darkTheme ? "border-b-slate-700" : "border-b-slate-200"
            }`}
          >
            Party Master
          </div>
          {allPermiss?.includes("master-party-create") && (
            <div className="">
              <div className="">
                <form action="" className="my-4 mb-8">
                  <div className="flex flex-col gap-x-3">
                    <div className="px-2 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 gap-x-3 bg-[#8CDDCD] py-1.5">
                      <div className="mb-2">
                        <label className="mr-2 block mb-[4px]">
                          Date of Introduction
                        </label>
                        <input
                          className={`py-1.5 rounded-lg px-3 outline-none border ${
                            darkTheme
                              ? "bg-gray-700 border-gray-500"
                              : "bg-white border-gray-500"
                          }`}
                          value={dateOfIntroduction}
                          onChange={(e) =>
                            setDateOfIntroduction(e.target.value)
                          }
                          type="date"
                          name="partydate"
                        />
                      </div>
                      <div className="mb-2">
                        <label>
                          Division{" "}
                          {/* <span className="text-red-500 font-bold">*</span> */}
                        </label>
                        <PartyDivisionSelect
                          selectedOption={division}
                          setSelectedOption={setDivision}
                          changingSelect={changingSelect}
                          setChangingSelect={setChangingSelect}
                        />
                      </div>
                      <div className="mb-2">
                        <label>Party Role</label>
                        <PartyRoleSelect
                          selectedOption={partyRole}
                          setSelectedOption={setPartyRole}
                          changingSelect={changingSelect}
                          setChangingSelect={setChangingSelect}
                        />
                      </div>
                      <div className="mb-2">
                        <label>Party is</label>
                        <PartyIsSelect
                          selectedOption={partyIs}
                          setSelectedOption={setPartyIs}
                          changingSelect={changingSelect}
                          setChangingSelect={setChangingSelect}
                        />
                      </div>
                    </div>

                    <div className="grid gap-x-3 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 px-2 py-1.5 bg-violet-200">
                      <MyInput
                        value={partyName}
                        onChange={(e) => setPartyName(e.target.value)}
                        label="Name"
                        type="text"
                        className="w-full"
                        mendatory="*"
                      />
                      <MyInput
                        value={shortName}
                        onChange={(e) => setShortName(e.target.value)}
                        label="Short Name"
                        type="text"
                        className="w-full"
                      />
                      <MyInput
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        label="Email"
                        type="text"
                        className="w-full"
                      />
                      <MyInput
                        value={aadhaarNo}
                        onChange={(e) => setAadhaarNo(e.target.value)}
                        label="Aadhaar No"
                        type="text"
                        className="w-full"
                        mendatory="*"
                      />
                      <MyInput
                        value={mobileNo}
                        onChange={(e) => setMobileNo(e.target.value)}
                        label="Mobile No"
                        type="text"
                        className="w-full"
                      />
                      <MyInput
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                        label="Phone No"
                        type="text"
                        className="w-full"
                      />
                      <div className="mb-2">
                        <label>
                          State{" "}
                          <span className="text-red-500 font-bold">*</span>
                        </label>
                        <StateSelect
                          selectedOption={state}
                          setSelectedOption={setState}
                          changingSelect={changingSelect}
                          setChangingSelect={setChangingSelect}
                        />
                      </div>
                      <div className="mb-2">
                        <label>
                          City <span className="text-red-500 font-bold">*</span>
                        </label>
                        <CitySelect
                          selectedOption={city}
                          setSelectedOption={setCity}
                          changingSelect={changingSelect}
                          setChangingSelect={setChangingSelect}
                        />
                      </div>
                      <MyTextarea
                        value={fullAddress}
                        onChange={(e) => setFullAddress(e.target.value)}
                        label="Full Address"
                        type="text"
                        className="w-full"
                        mendatory="*"
                      />

                      <div className="col-span-1 sm:col-span-3 md:col-span-3">
                        {/* <div className="grid gap-x-3 grid-cols-1 md:grid-cols-2 px-2 mb-3 bg-pink-200 py-1.5"> */}
                        <div className="grid grid-cols-2 md:grid-cols-4">
                          <div className="mb-1">
                            <label className="block mb-[2px]">ID Proof</label>
                            <label className="file-label text-sm">
                              <input
                                type="file"
                                id="file-input"
                                // accept=".jpg,.jpeg,.png"
                                onChange={(e) => IdentityProofFun(e)}
                                className="w-full text-sm"
                              />
                              Choose a file
                            </label>
                            <span id="file-name" className="file-name text-sm">
                              {idProofImgName}
                            </span>
                          </div>
                          <div className="mb-1">
                            <label className="block mb-[2px]">
                              GST Certificate
                            </label>
                            <label className="file-label text-sm">
                              <input
                                type="file"
                                id="file-input"
                                // accept=".jpg,.jpeg,.png"
                                onChange={(e) => GstCertificateFun(e)}
                                className="w-full text-sm"
                              />
                              Choose a file
                            </label>
                            <span id="file-name" className="file-name text-sm">
                              {gstCertImgName}
                            </span>
                          </div>
                          {/* </div> */}
                          {/* <div className="grid gap-x-3 grid-cols-1 md:grid-cols-2 px-2 mb-3 bg-pink-200 py-1.5"> */}
                          <div className="mb-1">
                            <label className="block mb-[2px]">
                              Bank Detail
                            </label>
                            <label className="file-label text-sm">
                              <input
                                type="file"
                                id="file-input"
                                // accept=".jpg,.jpeg,.png"
                                onChange={(e) => BankDetailFun(e)}
                                className="w-full text-sm"
                              />
                              Choose a file
                            </label>
                            <span id="file-name" className="file-name text-sm">
                              {bankDetImgName}
                            </span>
                          </div>
                          <div className="mb-1">
                            <label className="block mb-[2px]">
                              MSME Certificate
                            </label>
                            <label className="file-label text-sm">
                              <input
                                type="file"
                                id="file-input"
                                // accept=".jpg,.jpeg,.png"
                                onChange={(e) => MsmeCertificateFun(e)}
                                className="w-full text-sm"
                              />
                              Choose a file
                            </label>
                            <span id="file-name" className="file-name text-sm">
                              {msmeCertImgName}
                            </span>
                          </div>
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-x-3 px-2 bg-[#8CDDCD] py-1.5 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4">
                    {/* <div> */}
                    <MyInput
                      value={gstNo}
                      onChange={(e) => setGstNo(e.target.value)}
                      label="GST No"
                      type="text"
                      className="w-full"
                      mendatory="*"
                    />
                    {/* <button>Verify</button>
                  </div> */}

                    <MyInput
                      value={panNo}
                      onChange={(e) => setPanNo(e.target.value)}
                      label="Pan No"
                      type="text"
                      className="w-full"
                      mendatory="*"
                    />

                    <MyInput
                      value={bank}
                      onChange={(e) => setBank(e.target.value)}
                      label="Bank"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={bankAccount}
                      onChange={(e) => setBankAccount(e.target.value)}
                      label="Bank A/C No"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={bankBranch}
                      onChange={(e) => setBankBranch(e.target.value)}
                      label="Bank Branch"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={ifsc}
                      onChange={(e) => setIfsc(e.target.value)}
                      label="IFSC"
                      type="text"
                      className="w-full"
                    />

                    <div className="grid gap-x-3 grid-cols-2 px-2 py-1.5 sm:col-span-2">
                      <div className="mb-2 col-span-2 sm:col-span-1">
                        <label>TDS (Tax Deduction)</label>
                        <div className="flex items-center gap-6 mt-1">
                          <span>
                            <input
                              checked={isTds === "Yes" ? true : false}
                              type="radio"
                              name="is_tds"
                              value={"Yes"}
                              onChange={(e) => setIsTds(e.target.value)}
                              className="mr-1"
                            />
                            Yes
                          </span>
                          <span>
                            <input
                              checked={isTds === "No" ? true : false}
                              type="radio"
                              name="is_tds"
                              value={"No"}
                              onChange={(e) => setIsTds(e.target.value)}
                              className="mr-1"
                            />
                            No
                          </span>
                        </div>
                      </div>
                      <div className="mb-2 col-span-2 sm:col-span-1">
                        <label className="mr-2">Is Party MSME</label>
                        <div className="flex items-center gap-6 mt-1">
                          <span>
                            <input
                              checked={isMsme === "Yes" ? true : false}
                              type="radio"
                              name="is_msme"
                              value={"Yes"}
                              onChange={(e) => setIsMsme(e.target.value)}
                              className="mr-1"
                            />
                            Yes
                          </span>
                          <span>
                            <input
                              checked={isMsme === "No" ? true : false}
                              type="radio"
                              name="is_msme"
                              value={"No"}
                              onChange={(e) => setIsMsme(e.target.value)}
                              className="mr-1"
                            />
                            No
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid gap-x-3 grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 px-2 bg-violet-200 py-1.5 mb-4">
                    <MyInput
                      value={contactPersonOne}
                      onChange={(e) => setContactPersonOne(e.target.value)}
                      label="1st Contact Person"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={contactPersonOneMobile}
                      onChange={(e) =>
                        setContactPersonOneMobile(e.target.value)
                      }
                      label="1st Contact Person Mobile"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={contactPersonTwo}
                      onChange={(e) => setContactPersonTwo(e.target.value)}
                      label="2nd Contact Person"
                      type="text"
                      className="w-full"
                    />
                    <MyInput
                      value={contactPersonTwoMobile}
                      onChange={(e) =>
                        setContactPersonTwoMobile(e.target.value)
                      }
                      label="2nd Contact Person Mobile"
                      type="text"
                      className="w-full"
                    />
                  </div>

                  <div className="px-2">
                    {allPermiss?.includes("master-party-create") &&
                      submitAction === "submit" && (
                        <div className="flex items-center justify-center gap-x-1">
                          <Button
                            disabled={submitDisable}
                            type="submit"
                            onClick={(e) => Create(e)}
                          >
                            {submitDisable ? "Wait.." : "Submit"}
                          </Button>
                          <Button type="button" onClick={() => cancelUpdate()}>
                            Clear
                          </Button>
                        </div>
                      )}
                    {allPermiss?.includes("master-party-update") &&
                      submitAction === "update" && (
                        <div className="flex items-center justify-center gap-x-1">
                          <Button
                            disabled={updateDisable || disableParty}
                            type="submit"
                            onClick={(e) => updateARecord(e, getId)}
                          >
                            {updateDisable ? "Wait.." : "Update"}
                          </Button>
                          <Button onClick={() => cancelUpdate()}>Cancel</Button>
                        </div>
                      )}
                  </div>
                </form>
              </div>
            </div>
          )}

          {allPermiss?.includes("master-party-view") && (
            <div className="w-full px-2">
              <PartyPageForm
                editBtn={editBtn}
                firstPageList={firstPageList}
                links={links}
                firstPage={firstPage}
                setGetId={setGetId}
                spinner={spinner}
                totalNo={totalNo}
                from={from}
                to={to}
                editDisable={editDisable}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
